module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auction-select"
  }, [_c('b-dropdown', {
    staticClass: "w-100",
    class: {
      'no-border-radius': _vm.removeBorderRadius == true
    },
    attrs: {
      "id": "auction-select",
      "no-flip": "",
      "text": _vm.selectedText,
      "variant": "info"
    }
  }, _vm._l((_vm.auctions), function(auction) {
    return _c('b-dropdown-item', {
      key: auction.id,
      staticClass: "m-0",
      on: {
        "click": function($event) {
          return _vm.clickLink(auction)
        }
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(auction.title) + "\n\t\t")])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ebd57388"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/AuctionSelect.vue
// module id = 1347
// module chunks = 1